import classNames from 'classnames'

import Icon from 'components/Icon'
import Button from 'components/Button'

import style from './index.module.scss'

const Modal = ({ children, onClose, title }) => {
  const isSmall = !title

  return (
    <div
      className={
        classNames(
          style.block,
          isSmall && style.sm
        )
      }
    >
      <div
        className={style.shadow}
        onClick={onClose}
      />
      <div className={style.content}>
        <div className={style.wrapper}>
          {
            !isSmall &&
            <div className={style.header}>
              <h3 className={style.title}>{title}</h3>
              <Button
                classes={['secondary', 'sm', 'square', style.close]}
                onChange={onClose}
              >
                <Icon name={'icon-navigation-close'} />
              </Button>
            </div>
          }
          <div className={style.body}>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
